import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import FeatureStore from './store';
import Link from '@src/components/link';
import cx from 'classnames';
import SimpleSwiper from '@src/components/swiper/simple-swiper';

const styles = require('./index.less');

const Feature = ({ store }) => {
  store.use();

  const currentItem = store.swiperList[store.currentIndex] || {};

  return (
    <div className={styles.feature}>
      <div className={cx(styles.featureImg, { [styles.active]: store.isActive })}>
        {store.swiperList.map((item, index) => (
          <div className={cx(styles.featureImgItem, { [styles.active]: store.currentIndex === index })} key={index}>
            <img className={cx(styles.img)} src={item.img} alt={item.title} />
            <img className={cx(styles.leftImg)} src={item.leftImg} alt={item.title} />
          </div>
        ))}
      </div>
      <div className={styles.content}>
        <div className={styles.featureSwiper}>
          {store.swiperList.length >= 5 && (
            <React.Fragment>
              {store.showSwiper && (
                <SimpleSwiper params={store.params} key={store.swiperList.length}>
                  {store.swiperList.map((item, index) => (
                    <div className={styles.swiperItem} key={index}>
                      <img src={item.thumbImg} alt={item.title} />
                      <img className={styles.subTitle} src={item.subTitle} alt={item.title} />
                      <img className={styles.subTitleDisable} src={item.subTitleDisable} alt={item.title} />
                    </div>
                  ))}
                </SimpleSwiper>
              )}
            </React.Fragment>
          )}
          {store.swiperList.length < 5 && (
            <div className={styles.featureSwiperBox}>
              {store.swiperList.map((item, index) => (
                <div className={cx(styles.swiperItem, { [styles.active]: store.currentIndex === index })} key={index} onClick={() => store.changeSwiper(index)}>
                  <img src={item.thumbImg} alt={item.title} />
                  <div className={styles.title}>{item.title}</div>
                </div>
              ))}
            </div>
          )}
          {store.showSwiper &&
            store.swiperList.length >= 5 && (
              <div className={styles.swiperAction}>
                <Link className={cx(styles.swiperBtn, styles.prev)} onClick={() => store.changeSwiper('prev')} />
                <Link className={cx(styles.swiperBtn, styles.next)} onClick={() => store.changeSwiper('next')} />
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(Feature, FeatureStore);
